import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SEO } from '../components/SEO';
export const DienstenPage = () => {
  const services = [{
    title: 'Auto Wrappen',
    description: 'Transformeer uw auto met premium wraps en bescherm de originele lak met onze professionele wrapping service.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vPa5oULwHDcYzvNDCacQ1D/how-long-does-vinyl-wrap-last-1200x800-1-768x512.jpg',
    alt: 'Auto wrapping service - Professionele montage van vinyl wrap',
    price: '€1.250',
    link: '/diensten/autowrappen'
  }, {
    title: 'Ramen Tinten',
    description: 'Privacy en UV-bescherming met stijl. Hoogwaardige tinting voor een luxe uitstraling en optimaal comfort.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wNLF8ocqa3iPQaSqTR3jq1/carwindowtintingfranklintn-768x512.jpg',
    alt: 'Ramen tinten service - Vakkundige installatie van premium raamfolie',
    price: 'Vanaf €175',
    link: '/diensten/ramen-tinting'
  }, {
    title: 'Lichten Smoken',
    description: 'Geef uw auto een unieke, krachtige look met professioneel getinte lichten terwijl de originele lichtsterkte behouden blijft.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7Sz73Ji6DM6jfsjFgLE8Pn/G22-CSL-Red-768x511.webp',
    alt: 'Lichten smoken service - BMW met stijlvolle gerookte achterlichten',
    price: '€199',
    link: '/diensten/lichten-smoken'
  }, {
    title: 'Ontchromen',
    description: 'Verwijder chrome elementen voor een cleane, moderne look die uw auto direct onderscheidt van de massa.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8h8EqFfY6iTr2pX1pd2aXy/AS_Dechrome_Hero-768x512.jpg',
    alt: 'Ontchromen service - Matte zwarte auto met volledige chrome delete',
    price: '€349',
    link: '/diensten/ontchromen'
  }, {
    title: 'AlloyGator',
    description: 'Bescherm uw velgen tegen schade van stoepranden met onze premium AlloyGator wielkastbeschermers.',
    imageUrl: 'https://uploadthingy.s3.us-west-1.amazonaws.com/d9Rkg47SKWSVtxvpKhbWvX/1_%281%29.jpg',
    alt: 'AlloyGator wielkastbeschermer geïnstalleerd op een zwarte velg',
    price: '€399',
    link: '/diensten/alloygator'
  }, {
    title: 'Maatwerk Advies',
    description: 'Op zoek naar een unieke styling oplossing? Wij bieden persoonlijk advies en maatwerk voor uw specifieke wensen en auto.',
    imageUrl: 'https://images.unsplash.com/photo-1560179707-f14e90ef3623?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2073&q=80',
    alt: 'Maatwerk advies voor car styling - Professionele consultatie',
    price: 'Op maat',
    link: '/diensten/maatwerk-advies'
  }];
  return <main data-id="element-1475">
      <SEO title="Onze Diensten | BKCustoms Car Styling Almere" description="Ontdek ons complete aanbod van premium auto styling diensten in Almere: Auto wrappen, ramen tinten, lichten smoken, ontchromen en meer bij BKCustoms." canonical="/diensten" data-id="element-1476" />
      {/* Header Banner */}
      <div className="relative bg-[#0a0a0a] py-28" data-id="element-1477">
        <div className="absolute inset-0 overflow-hidden" data-id="element-1478">
          <div className="absolute inset-0 bg-black/80 z-10" data-id="element-1479"></div>
          <img src="https://images.unsplash.com/photo-1619771914272-e3c1ba17ba4d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Auto customization services" className="w-full h-full object-cover object-center" data-id="element-1480" />
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-1481">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-1482">
            Onze <span className="text-[#D6281F]" data-id="element-1483">Diensten</span>
          </h1>
          <p className="text-white/80 max-w-2xl mx-auto text-lg" data-id="element-1484">
            Ontdek ons complete aanbod van premium auto styling en customization
            diensten door ervaren specialisten.
          </p>
        </div>
      </div>
      {/* Services Grid */}
      <section className="bg-[#0a0a0a] py-12 sm:py-16" data-id="element-1485">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1486">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-1487">
            {services.map((service, index) => <Link key={index} to={service.link} className="group flex flex-col h-full bg-[#111111] overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-all duration-300" data-id="element-1488">
                <div className="relative aspect-[16/9] overflow-hidden" data-id="element-1489">
                  <img src={service.imageUrl} alt={service.alt} className="w-full h-full object-cover object-center transform group-hover:scale-105 transition-transform duration-500 ease-out" data-id="element-1490" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-1491"></div>
                </div>
                <div className="flex flex-col flex-grow p-5" data-id="element-1492">
                  <h3 className="text-xl font-bold text-white mb-2 group-hover:text-[#D6281F] transition-colors duration-300" data-id="element-1493">
                    {service.title}
                  </h3>
                  <p className="text-[#CCCCCC] text-sm mb-4 flex-grow" data-id="element-1494">
                    {service.description}
                  </p>
                  <div className="inline-flex items-center text-white text-sm group-hover:text-[#D6281F] transition-colors duration-300 mt-auto font-medium" data-id="element-1495">
                    <span className="mr-2" data-id="element-1496">Meer informatie</span>
                    <ArrowRightIcon size={14} className="transition-transform duration-300 group-hover:translate-x-1" data-id="element-1497" />
                  </div>
                </div>
              </Link>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="bg-[#0a0a0a] py-16 border-t border-[#222]" data-id="element-1498">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-1499">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-1500">
            Klaar voor een unieke auto styling?
          </h2>
          <p className="text-white/80 mb-8" data-id="element-1501">
            Neem contact met ons op voor een persoonlijk advies of maak direct
            een afspraak voor jouw auto.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-1502">
            <Link to="/afspraak-maken" className="bg-[#D6281F] hover:bg-[#D6281F]/90 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide" data-id="element-1503">
              Afspraak maken
            </Link>
            <Link to="/contact" className="bg-white/5 hover:bg-white/10 text-white px-8 py-4 rounded-md transition-all duration-300 font-medium tracking-wide border border-white/10" data-id="element-1504">
              Vraag ons advies
            </Link>
          </div>
        </div>
      </section>
    </main>;
};